import { ApiError } from "../../services/apiClient";
import { apiErrorToMessage } from "../../services/apiError";
import { passwordErrorFromCode, type PasswordChangeError } from "./passwordChange";

// Map sign-in / password-change failures to localized, non-revealing messages. Pure (strings
// are passed in) so it is unit-testable without React.

interface AuthStrings {
  admin: { sessionExpired: string; notAuthorized: string };
  errors: Record<string, string>;
  auth: { failed: string; locked: string; unavailable: string };
  settings: { errors: Record<PasswordChangeError | "currentIncorrect" | "locked", string> };
}

export function signInErrorMessage(err: unknown, t: AuthStrings): string {
  if (err instanceof ApiError) {
    if (err.status === 401) return t.auth.failed;
    if (err.status === 429) return t.auth.locked;
    if (err.status === 503) return t.auth.unavailable;
  }
  return apiErrorToMessage(err, t);
}

export function passwordChangeErrorMessage(err: unknown, t: AuthStrings): string {
  if (err instanceof ApiError) {
    if (err.status === 429) return t.settings.errors.locked;
    if (err.status === 503) return t.auth.unavailable;
    const key = passwordErrorFromCode(err.problem.type);
    if (key) return t.settings.errors[key];
  }
  return apiErrorToMessage(err, t);
}
